export enum chatTypes {
  MESSAGE = "message",
  EVENT = "event"
}